import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import persistState from "redux-localstorage";

import { serialize, deserialize } from "utils/localstorage";
import { ENABLE_REDUX_DEVTOOLS } from "config/constants";
import {
  CHECK_ITEM_LOCK_REQUESTED,
  CHECK_ITEM_LOCK_SUCCEEDED,
  CHECK_ITEM_LOCK_FAILED,
} from "editor/actions/locking";
import getClient from "utils/getClient";
import edenApp from "reducers";

const composeEnhancers =
  (ENABLE_REDUX_DEVTOOLS &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      trace: true,
      actionsBlacklist: [
        CHECK_ITEM_LOCK_REQUESTED,
        CHECK_ITEM_LOCK_SUCCEEDED,
        CHECK_ITEM_LOCK_FAILED,
      ],
    })) ||
  compose;

export default function() {
  return createStore(
    edenApp,
    composeEnhancers(
      applyMiddleware(thunk.withExtraArgument(getClient)),
      persistState(["isAuthenticated", "token", "client", "user"], {
        serialize,
        deserialize,
      })
    )
  );
}
